import { Environment } from '@config';
import { buildConfig } from '../app/configs/gb/sidedoor/build/build-config';

// The environment configuration used for local development and bootstrapping the application.
export const environment: Environment = {
  ...buildConfig,
  name: 'dev',
  production: false,
};
